import React from "react";
import QRCode from "react-qr-code";
import PageBottomButton from "./PageBottomButtons";
import { useSelector } from "react-redux";
import { DateTimeHandler } from "./../../../utils/Helper";
import "react-loading-skeleton/dist/skeleton.css";
import { ArrowDropDown, ArrowDropUp } from "@material-ui/icons";
import styled from "styled-components";

const Container = styled.div`
  width: 100% !important;
  min-height: 300px;
  height: auto;
  margin: 0;
  justify-content: center;
  align-items: center;
`;

const FontSizeRes = styled.div`
  @media (max-width: 998px) {
    font-size: 15px;
  }
  @media (min-width: 998px) {
    font-size: 18px;
  }
`;


const TicketInformationMD = (props) => {
  const [collapsed, setCollapsed] = React.useState({});
  const [isAv, setIsAv] = React.useState(true);
  const { state } = useSelector((state) => ({
    state: state.search,
  }));

  const isActive = (depDate, status) => {
    const today = new Date();
    depDate = depDate.split('T')[0];
    const compareDate = new Date(depDate);
    if (status == 4) {
      return "استرداد شده";
    }
    if (compareDate < today) {
      return "منقضی";
    } else if (compareDate > today) {
      return "فعال";
    }
  };
  function parseArray(data) {
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  }
  return (
    <>
      {props.data
        ? props.data.travelReports.map((el) => {
          return (
            <div className="my-10 px-3 py-7 justify-content-between container bg-white align-items-center travels-cards">
              <div className="mt-2 d-lg-flex col-12 mx-0 row">
                <div className="d-flex justify-content-between col-md-11 col-lg-9 align-items-center">
                  <FontSizeRes
                    className="text-secondary col-2 col-lg-3"
                    style={{ opacity: "0.85" }}
                  >
                    {el.id ? el.id : null}
                  </FontSizeRes>
                  <FontSizeRes
                    className="text-secondary col-2 col-lg-3"
                    style={{ opacity: "0.85" }}
                  >
                    {el.ticketSource.title ? el.ticketSource.title : null}
                  </FontSizeRes>
                  <FontSizeRes
                    className="text-secondary col-2 col-lg-3"
                    style={{ opacity: "0.85" }}
                  >
                    {el.ticketDest.title ? el.ticketDest.title : null}
                  </FontSizeRes>
                  <FontSizeRes
                    className="text-secondary col-3 col-lg-3"
                    style={{ opacity: "0.85" }}
                  >
                    {el.Travel.departureDatetime
                      ? DateTimeHandler(el.Travel.departureDatetime).date
                      : null}
                  </FontSizeRes>
                  <FontSizeRes
                    className="d-none d-lg-block col-lg-0"
                    style={{ opacity: "0.85" }}
                  >
                  </FontSizeRes>
                  <FontSizeRes
                    className="d-flex row col-5 col-md-3 align-items-left"
                    style={{ justifyContent: "flex-end", cursor: "pointer" }}
                    onClick={() => {
                      let colCopy = collapsed;
                      if (colCopy[el.id]) {
                        colCopy[el.id] = !colCopy[el.id];
                      } else {
                        colCopy[el.id] = true;
                      }
                      setCollapsed(colCopy);
                      setIsAv(false);
                      setTimeout(() => {
                        setIsAv(true);
                      });
                    }}
                  >
                    <FontSizeRes className="col-6 col-md-4 d-flex align-items-center">مشاهده</FontSizeRes>
                    <FontSizeRes className="col-4">
                      {!collapsed[el.id] ||
                        (!collapsed[el.id] === false && isAv) ? (
                        <ArrowDropDown style={{ fontSize: "3.5rem" }} />
                      ) : (
                        <ArrowDropUp style={{ fontSize: "3.5rem" }} />
                      )}
                    </FontSizeRes>
                  </FontSizeRes>
                </div>

              </div>

              {collapsed[el.id] && collapsed[el.id] === true && isAv ? (
                <>
                  <div
                    className="line mx-auto my-8"
                    style={{ width: "98%" }}
                  ></div>
                  <div className="d-flex mt-5">
                    <div className="col-lg-9 col-md-8">
                      <div className="col-md-12 d-block d-lg-flex align-items-center">
                        <p className="col-md-9 mt-5 mt-lg-0">
                          {" "}
                          <span style={{ fontSize: 18 }}>
                            <b>شماره سفارش: </b>
                          </span>
                          <span
                            style={{
                              fontSize: 17,
                              marginRight: 5,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el.id ? el.id : null}
                          </span>
                        </p>
                        <p className="col-md-5 mt-5 mt-lg-0">
                          <span style={{ fontSize: 18 }}>
                            <b>تاریخ سفارش: </b>
                          </span>
                          <span
                            style={{
                              fontSize: 19,
                              marginRight: 5,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el.createdAt
                              ? new Date(el.createdAt).toLocaleDateString("fa-IR")
                              : null}

                          </span>
                        </p>
                      </div>
                      <div className="col-md-12 d-block d-lg-flex mt-5 justify-content-between">

                        <p className="col-11 col-md-5 col-lg-3">
                          {" "}
                          <span style={{ fontSize: 17 }}>
                            <b>ساعت حرکت:</b>{" "}
                          </span>
                          <span
                            style={{
                              fontSize: 16,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el.Travel.departureDatetime
                              ? DateTimeHandler(el.Travel.departureDatetime).time
                              : null}
                          </span>
                        </p>

                        <div className="d-lg-block w-100 col-6"></div>

                        <p className="col-12 col-md-6">
                          {" "}
                          <span>
                            <b
                              style={{ fontSize: 18 }}
                              className="white-nowrap"
                            >
                              تاریخ حرکت:
                            </b>
                          </span>
                          <span
                            style={{
                              fontSize: 17,
                              marginRight: 5,
                            }}
                          >
                            {el.Travel.departureDatetime
                              ? DateTimeHandler(el.Travel.departureDatetime).date
                              : null}
                          </span>
                        </p>
                      </div>
                      <div className="col-md-12 d-block d-lg-flex mt-5 justify-content-between">
                        <div className="col-md-9">
                          <span className="font-16">
                            <b>نام مسافر/مسافرین: </b>
                          </span>
                          <span
                            className="font-16 white-nowrap"
                            style={{
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el.TravelTicketDetails ?
                              el.TravelTicketDetails.map((ticket, index) =>
                              (
                                `${ticket.passengerFirstName} ${" "} ${ticket.passengerLastName}
                                 ${index === el.TravelTicketDetails.length - 1 ? " " : " , "}
                                `
                              ))
                              : null}
                          </span>
                        </div>
                        <div className="col-md-5 mt-5 mt-lg-0">
                          <span className="font-16">
                            <b>شماره صندلی: </b>
                          </span>
                          <span
                            className="font-16 white-nowrap"
                            style={{
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el.TravelTicketDetails ?
                              el.TravelTicketDetails.map((ticket, index) =>
                              (
                                `${ticket.seatNumber} 
                                 ${index === el.TravelTicketDetails.length - 1 ? " " : " , "}
                                `
                              ))
                              : null}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-12 d-block d-lg-flex mt-lg-10 mt-5 justify-content-between">
                        <div className="col-md-9 mt-5 mt-lg-0">
                          <span className="font-16">
                            <b>قیمت اصلی: </b>
                          </span>
                          <span
                            className="font-16 white-nowrap"
                            style={{
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el.Travel ? el.Travel.basePrice.toLocaleString('ar-EG') : null}
                          </span>
                        </div>

                        <div className="col-md-5 mt-5 mt-lg-0">
                          <span className="font-16">
                            <b>قیمت با تخفیف: </b>
                          </span>
                          <span
                            className="font-16 white-nowrap"
                            style={{
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el ? el.orginalPrice.toLocaleString('ar-EG') : null}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-12 d-block mt-lg-10 mt-5 d-lg-flex">
                        <p className="col-md-4 col-lg-3 col-11">
                          {" "}
                          <span style={{ fontSize: 18 }}>
                            <b>وضعیت : </b>
                          </span>
                          <span
                            style={{
                              fontSize: 17,
                              marginRight: 5,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el.Travel.departureDatetime
                              ? isActive(el.Travel.departureDatetime, el.travelTicketStatusId)
                              : "دریافت نشد"}
                          </span>
                        </p>
                      </div>
                      <div>
                        {" "}
                        <PageBottomButton data={el} />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-4 d-none d-md-block p-3">
                      {el.qrCode ? (
                        <QRCode value={el.qrCode} size="200" />
                      ) : null}
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          );
        })
        : null}
    </>
  );
};

export default TicketInformationMD;
